/** Срок подписки по-человечески: «осталось N дней», цветом при <14 днях / истёк. */

const DAY = 24 * 60 * 60 * 1000
const WARN_DAYS = 14

export function daysLeft(expiresAt: string | null, now: Date = new Date()): number | null {
  if (!expiresAt) return null
  const end = new Date(expiresAt).getTime()
  return Math.ceil((end - now.getTime()) / DAY)
}

export function termTone(expiresAt: string | null, now: Date = new Date()): 'ok' | 'warn' | 'expired' {
  const left = daysLeft(expiresAt, now)
  if (left === null) return 'ok'
  if (left <= 0) return 'expired'
  if (left < WARN_DAYS) return 'warn'
  return 'ok'
}

export function termLabel(
  expiresAt: string | null,
  now: Date,
  t: (k: string, vars?: Record<string, unknown>) => string,
): string {
  const left = daysLeft(expiresAt, now)
  if (left === null) return t('termUnlimited')
  if (left <= 0) return t('termExpired')
  return t('termDaysLeft', { days: left })
}
